module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": _vm.loading.tela ? 'Carregando súmula' : 'Súmula ' + (!_vm._.isNull(this.$route.params.id) ? this.$route.params.id : '')
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_c('span', {
    staticClass: "col-md-5"
  }, [_vm._v(_vm._s(_vm.loading.tela ? 'Carregando súmula...' : 'Súmula ' + (!_vm._.isNull(this.$route.params.id) ? 'ID ' + this.$route.params.id : '')))]), _vm._v(" "), (!_vm.loading.tela || _vm.ehVisualizacao) ? _c('span', {
    staticClass: "col-md-7 bloco_botoes"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.imprimir($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Imprimir")])], 1) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('sumula', {
    attrs: {
      "idProcesso": this.$route.params.id
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8a56b9ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/alteracoesProjeto/Sumula.vue
// module id = 2042
// module chunks = 1